import Icon from '../components/Icon.vue'

Icon.register({
  compass: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M225.4 233.4C212.9 245.9 212.9 266.1 225.4 278.6 237.9 291.1 258.1 291.1 270.6 278.6 283.1 266.1 283.1 245.9 270.6 233.4 258.1 220.9 237.9 220.9 225.4 233.4zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM374.1 156.1L308.2 300.4A31.9-31.9 0 0 0 292.4 316.2L148.1 382.1C131.4 389.8 114.3 372.6 121.9 355.9L187.8 211.6A31.9-31.9 0 0 0 203.6 195.8L348 129.9C364.6 122.3 381.8 139.4 374.1 156z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/compass.js
// module id = kNCX
// module chunks = 144